module.exports = __webpack_public_path__ + "img/sample08.ed7dd451.gif";